<template>
  <div class="footer">
    <div class="container">
      <div class="row l_flex_row">
        <div class="left">
          <div class="navbox l_flex_row">
            <router-link to="/" class="nav-item l_flex_row">
              <span>首页</span>
              <span class="li"></span>
            </router-link>
            <router-link
              :to="item.title | filterLink"
              class="nav-item l_flex_row"
              v-for="(item, index) in navMenus"
              :key="index"
            >
              <span>{{ item.title }}</span>
              <span class="li"></span>
            </router-link>
            <router-link to="/activity/undefined" class="nav-item l_flex_row">
              <span>活动中心</span>
              <span class="li"></span>
            </router-link>
            <router-link to="/my" class="nav-item l_flex_row">
              <span>个人中心</span>
            </router-link>
          </div>
        </div>
        <div class="right qr">
          <img src="../assets/images/ewm_dl.jpg" alt="二维码" class="qr-img" />
        </div>
      </div>
      <div class="botbox l_flex_row">
        <div class="left">
          <p>北京一博千禧科技有限公司</p>
          <p>电信信息业务许可证：京B2-20180237</p>
          <p>广播电视节目制作经营许可证：（京）字第16582号</p>
          <p>
            Copyright@2019-2029语林 All Rights Reserved &nbsp;&nbsp;
            &nbsp;&nbsp;
            <a
              target="_blank"
              class="link_style_none"
              href="https://beian.miit.gov.cn/#/Integrated/index"
              >京ICP备16011149号-6</a
            >
          </p>
          <p>
            <a
              target="_blank"
              class="record"
              href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802037573"
            >
              <img class="record_img" src="../assets/images/ba.png" alt="" />
              <p class="text">京公网安备11010102007034号</p>
            </a>
          </p>
        </div>
        <div class="right">
          <p>服务热线：400-969-6261</p>
          <p>(如对平台内容有任何疑问，请与我们联系))</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      navMenus: [
        {
          name: "深度阅读"
        },
        {
          name: "有知"
        },
        {
          name: "视频讲堂"
        },
        {
          name: "青青听"
        },
        {
          name: "青青写"
        }
      ],
      agencyId: ""
    };
  },
  watch: {},
  computed: {},
  methods: {
    async getMenu() {
      try {
        let menu = sessionStorage.getItem("menu");
        if (menu) {
          this.navMenus = JSON.parse(menu);
        } else {
          let res = await this.getAgencyId();
          let list = await this.getMenubyNet(this.agencyId);
        }
      } catch (error) {}
    },
    //
    async getMenubyNet(ogran_id) {
      try {
        let res = await this.$api.getExpendMenu({
          data: {
            ogran_id: ogran_id
          },
          params: {}
        });
        let list = res.data.filter(item => {
          if (item.title == "开心") {
            return false;
          }
          return true;
        });
        this.navMenus = list;
      } catch (error) {}
    },
    // 获取机构id
    async getAgencyId() {
      try {
        if (this.$route.params.id && this.$route.name == "Index") {
          this.agencyId = this.$route.params.id;
        } else {
          let id = localStorage.getItem("ogran_id");
          if (id) {
            this.agencyId = id;
          } else {
            let res = await this.getAgencyIdbyIP();
            this.agencyId = res.ogran_id;
          }
        }
      } catch (error) {}
    },
    // 根据ip获取机构id和机构名
    async getAgencyIdbyIP() {
      try {
        let res = await this.$api.getAgencyId({
          params: {
            group: "pc",
            ogran_id: id ? id : ""
          },
          data: {}
        });
        return res.data;
      } catch (error) {}
    }
  },
  filters: {
    filterLink(value) {
      let rules = [
        {
          name: "视频讲堂",
          url: "/videonote"
        },
        {
          name: "有知",
          url: "/knowing"
        },
        {
          name: "青青写",
          url: "/greenwrite"
        },
        {
          name: "深度阅读",
          url: "/deepread"
        },
        {
          name: "青青听",
          url: "/greenlisten"
        }
      ];
      for (let el of rules) {
        if (value == el.name) {
          return el.url;
        }
      }
    }
  },
  created() {
    this.getMenu();
  },
  mounted() {}
};
</script>
<style lang="less" scoped>
.footer {
  @green: #3370ff;
  @white: #fff;
  @orange: #ffb463;
  background-color: @green;
  border-top: 10px solid @orange;
  .container {
    width: 1200px;
    margin: 0 auto;
    .row {
      height: 200px;
      justify-content: space-between;
      .left {
        flex: 1;
        .navbox {
          color: @white;
          .nav-item {
            margin-right: 10px;
            cursor: pointer;
            color: @white;
            font-size: 14px;
            .li {
              margin-left: 10px;
              display: inline-block;
              width: 2px;
              height: 14px;
              background-color: @white;
            }
          }
        }
      }
      .right {
        .qr-img {
          width: 100px;
          height: 100px;
          object-fit: contain;
        }
      }
    }
    .botbox {
      padding: 0px 0 40px;
      justify-content: space-between;
      align-items: flex-end;
      color: @white;
      p {
        // line-height: 1.6em;
        line-height: 25px;
        font-size: 14px;
      }
      .right {
        text-align: right;
      }
      .record {
        display: flex;
        align-items: center;
        color: #fff;
        .record_img {
          margin-right: 10px;
        }
      }
    }
  }
  .link_style_none {
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue